export default "__VITE_ASSET__f16c8544__"